import { useState, useRef, useEffect } from "react";

export default function CustomDropdown({ selected, onSelect, options = [], icon }) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={ref} className="relative inline-block">
      {/* Display box */}
      <div
        onClick={() => setIsOpen((o) => !o)}
        className="flex items-center justify-between w-[365px] h-[38px] px-3 border rounded-[6px] cursor-pointer"
      >
        {icon && <span className="mr-2">{icon}</span>}
        <span className={`flex-1 text-[13px] font-outfit ${selected ? "text-[#18101C] font-medium" : "text-[#73607B] font-normal"}`}>
          {selected || "Choose a custom Field"}
        </span>
        <img src="/chevron-down.svg" alt="▼" className="w-6 h-6 ml-2" />
      </div>

      {/* Dropdown menu */}
      {isOpen && (
        <div className="absolute top-full mt-1 w-[365px] max-h-[150px] bg-[#FEF9F7] border border-[rgba(0,0,0,0.10)] rounded-[4px] overflow-y-auto z-10 shadow-lg">
          {options.map((option) => {
            const isSelected = selected === option;
            return (
              <button
                key={option}
                onClick={() => {
                  onSelect(option);
                  setIsOpen(false);
                }}
                className={`flex items-center w-full h-[30px] px-3 text-[14px] font-outfit font-medium text-[#52525B] hover:bg-[#EFE2FF] ${
                  isSelected ? "bg-[rgba(139,85,221,0.16)]" : ""
                }`}
              >
                {option}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
